export default class Parallax {
  constructor() {
    this.bgText = [...document.querySelectorAll('[data-bg-text]')]
    this.bgImg = [...document.querySelectorAll('[data-bg-img]')]
    this.init();
  }
  
  init() {
    this.setup();
    this.parallaxBgText();
    this.parallaxBgImg();
  }

  setup() {
    this.bgText.forEach(element => gsap.set(element, { xPercent: element.dataset.startX ?? 10 }));
    this.bgImg.forEach(element => gsap.set(element, { yPercent: 4 }));
  }

  parallaxBgText() {
    this.bgText.forEach(element => {
      gsap.to(element, {
        xPercent: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: element,
          start: 'top bottom',
          end: 'bottom 50%',
          scrub: 3,
        },
      });
    });
  }

  parallaxBgImg() {
    this.bgImg.forEach(element => {
      gsap.to(element, {
        yPercent: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: element,
          start: 'top bottom',
          end: 'bottom 50%',
          scrub: 1,
        },
      });
    });
  }
}
